module.exports = __webpack_public_path__ + "img/erp-logos_0041_access.9d213cf7.jpg";